import React, {useState, useEffect, useRef} from 'react';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import SelectInfinite from '../../components/FormFields/SelectInfinite';
import InputText from '../../components/FormFields/InputText';
import TextArea from '../../components/FormFields/Textarea';
import * as yup from 'yup';
import {getLanguage, t} from 'react-switch-lang';
import {Col, Row} from 'react-bootstrap';
import PageHeader from './components/PageHeader';
import {useHistory} from 'react-router-dom';
import {
  GetPotentionalRisk,
  getPotentionalRisks,
  getAllSubProcesses,
  addIncurredRisk,
  getAllSubCauses,
  getDepartment, getAllSubCategories,
} from '../../services/IncurredEvent/incurredEventApi';
import SelectList from '../../components/select/SelectList';
import {useUserContext} from '../../contexts/UserContext';
import {useDepartmentContext} from '../../contexts/DepartmentContext';
import Toast from '../../components/toast/Toast';
import Swal from 'sweetalert2';
import './addPotentionalRisk.scss';
import PreventTransitionPrompt from '../../components/preventTransitionprompt/PreventTransition';
import InputDate from "../../components/FormFields/inputDate/InputDate";
import {format} from 'date-fns';
import LossModal from "./components/modals/LossModal";
import editImage from "./components/img/edit.svg";
import deleteImage from './components/img/delete.svg'
import {
  parseFormattedNumber,
  maxDecimalNumber,
  onDecimalNumberInputChange,
  testValidNumber, handlePasteAndValidate, formatNumber, testIsGreaterThanMin, formatNumberInput,
} from '../../utils/helpers';
import FileUploadSection from '../../components/FileUploadSection/FileUploadSection'
import {getAllRiskTypes} from "../../services/reports/reports";
import {appModules, defaultMinValueZero, validDouble} from '../../utils/const';

const AddIncurredRisk = (props) => {
  const lang = getLanguage();
  const user = useUserContext();
  const userDepartment = useDepartmentContext();
  const [deletedLossIds, setDeletedLossIds] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [disableSubprocess, setDisableSubPorcess] = useState(true);
  const [disableSubCauses, setDisableSubCauses] = useState(true);
  const [disableSubCategories, setDisableSubCategories] = useState(true);
  const [subProcesses, setSubProcesses] = useState([]);
  const [subCauses, setSubCauses] = useState([]);
  const [disableRiskCauses, setDisableRiskCauses] = useState(true);
  const [subCategories, setSubCategories] = useState([]);
  const [potentionalRisks, setPotentionalRisks] = useState([]);
  const [files, setFiles] = useState([]);
  const [riskEstimation, setRiskEstimation] = useState();
  const [isAdding, setIsAdding] = useState(true);
  const [lossModalOpen,setLossModalOpen] = useState(false);
  const [isEdit,setIsEdit] = useState(false);
  const [lossData, setLossData] = useState([]);
  const [currentID,setCurrentID] = useState();
  const [userResponsibleLogin,setUserResponsibleLogin] = useState();
  const [yesNoOptions,setYesNoOptions] = useState(  lang === 'eng'
      ? [{value: true, label: 'Yes'},{value:false,label:'No'}]
      : [{value: true, label: 'Da'},{value:false,label:'Ne'}])
  let history = useHistory();
  const [subprocessPage, setSubprocessPage] = useState(0);
  const [hasMoreSubprocesses, setHasMoreSubprocesses] = useState(true);
  const [loadingSubprocesses, setLoadingSubprocesses] = useState(false);
  const [subCausePage, setSubCausePage] = useState(0);
  const [hasMoreSubCauses, setHasMoreSubCauses] = useState(true);
  const [loadingSubCauses, setLoadingSubCauses] = useState(false);
  const [subCategoryPage, setSubCategoryPage] = useState(0);
  const [hasMoreSubCategories, setHasMoreSubCategories] = useState(true);
  const [loadingSubCategories, setLoadingSubCategories] = useState(false);

  const [schema, setSchema] = useState(
    yup.object().shape({
      riskType: yup.object().nullable().required(t('message.fieldRequired')),
      title: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(150, t('message.max', {max: 150})),
      description: yup
        .string()
        .trim()
        .max(2048, t('message.max2048'))
        .required(t('message.fieldRequired')),
      harmfulEventDescription: yup
        .string()
        .trim()
        .max(2048, t('message.max2048'))
        .required(t('message.fieldRequired')),
      riskCauseId: yup.object().nullable().required(t('message.fieldRequired')),
      riskSubCauseId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      creditRiskRelated: yup.object().nullable().required(t('message.fieldRequired')),
      departmentStakeholderId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      riskCategoryId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      riskSubCategory: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      userResponsible: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      estimatedGrossLost: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
          .test('is-valid-number', t('message.mustBeNumber'), (value) => {
            return testValidNumber(value);
          }).test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
            return maxDecimalNumber(value);
          })
        // .matches(validDouble, t('message.onlyDecimalNumbers'))
        .typeError(t('message.onlyDecimalNumbers')),
      // riskMitigationModeName: yup.object().nullable().required(t('message.fieldRequired')),
      process: yup.object().nullable().required(t('message.fieldRequired')),
      subprocessId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      businessLineId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      typeGainLossId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      // methodologyId: yup
      //   .object()
      //   .nullable()
      //   .required(t('message.fieldRequired')),
      comment: yup.string().trim().max(2048, t('message.max2048')),
      departmentSourceId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      riskMitigationModeName: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      eventOccurrence: yup
          .string()
          .nullable()
          .required(t('message.fieldRequired')),
      riskOccurrenceDiscoveredAt: yup
          .date()
          .nullable()
          .required(t('message.fieldRequired')),
      keyIndicatorValue: yup
        .string()
        .trim()
        .when('keyIndicatorId', {
          is: (val) => (val?.escalationCalculationType !== 'COUNTER' && val?.escalationCalculationType !== undefined),
          then: (schema) =>
            schema
              .required(t('message.fieldRequired'))
              .matches(validDouble, t('message.onlyDecimalNumbersMinZero'))
              .typeError(t('message.onlyDecimalNumbersMinZero')),
          otherwise: (schema) => schema.nullable(),
        }),
      lossChargedInsurance: yup
        .string()
        .when('netLoss', {
          is: (val) => !!val,
          then: yup
            .string()
            .required(t('message.fieldRequired'))
            .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) =>
              testIsGreaterThanMin(value, defaultMinValueZero)
            )
            .test('is-valid-number', t('message.mustBeNumber'), (value) =>
              testValidNumber(value)
            )
            .test('max-two-decimals', t('message.maxTwoDecimals'), (value) =>
              maxDecimalNumber(value)
            ),
          otherwise: yup.string().nullable(),
        }),
      lossChargedOther: yup
        .string()
        .when('netLoss', {
          is: (val) => !!val,
          then: yup
            .string()
            .required(t('message.fieldRequired'))
            .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) =>
              testIsGreaterThanMin(value, defaultMinValueZero)
            )
            .test('is-valid-number', t('message.mustBeNumber'), (value) =>
              testValidNumber(value)
            )
            .test('max-two-decimals', t('message.maxTwoDecimals'), (value) =>
              maxDecimalNumber(value)
            ),
          otherwise: yup.string().nullable(),
        })
    })
  );

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {handleSubmit, watch, reset, setValue,trigger, errors} = methods;
  const watchRiskType = watch('riskType');
  const watchProcess = watch('process');
  const watchRiskCause = watch('riskCauseId');
  const watchDepartmentSourceId = watch('departmentSourceId');
  const prevProcessRef = useRef();
  const prevRiskCause = useRef();
  const prevRiskCategory = useRef();
  const watchRiskCategory = watch('riskCategoryId');
  const watchKeyRiskIndicator = watch('keyIndicatorId');
  const watchRiskSubCategory = watch('riskSubCategory');
  const watchNetLoss = watch('netLoss')

  // const fetchSubprocesses = async (pageToLoad = 0, replace = false) => {
  //   if (!watchProcess?.value) return;
  //
  //   try {
  //     setLoadingSubprocesses(true);
  //     const {data} = await getAllSubProcesses(
  //       watchProcess.value,
  //       pageToLoad,
  //       20
  //     );
  //
  //     const mapped = data.map((item) =>
  //       lang === 'eng'
  //         ? { value: item.id, label: item.nameEn }
  //         : { value: item.id, label: item.name }
  //     );
  //
  //     setSubProcesses((prev) =>
  //       replace ? mapped : [...prev, ...mapped]
  //     );
  //
  //     setSubprocessPage(pageToLoad);
  //     setHasMoreSubprocesses(data.length === 20);
  //   } catch (e) {
  //   } finally {
  //     setLoadingSubprocesses(false);
  //   }
  // };
  // const fetchSubcauses = async (pageToLoad = 0, replace = false) => {
  //   if (!watchRiskCause?.value) return;
  //
  //   try {
  //     setLoadingSubCauses(true);
  //     const {data} = await getAllSubCauses(
  //       watchRiskCause.value,
  //       watchRiskSubCategory?.value,
  //       pageToLoad,
  //       20
  //     );
  //
  //     const mapped = data.map((item) =>
  //       lang === 'eng'
  //         ? { value: item.id, label: item.nameEn }
  //         : { value: item.id, label: item.name }
  //     );
  //
  //     setSubCauses((prev) =>
  //       replace ? mapped : [...prev, ...mapped]
  //     );
  //
  //     setSubCausePage(pageToLoad);
  //     setHasMoreSubCauses(data.length === 20);
  //   } catch (e) {
  //   } finally {
  //     setLoadingSubCauses(false);
  //   }
  // };
  // const fetchSubCategories = async (pageToLoad = 0, replace = false) => {
  //   if (!watchRiskCategory?.value) return;
  //
  //   try {
  //     setLoadingSubCategories(true);
  //     const {data} = await getAllSubCategories(
  //       watchRiskCategory.value,
  //       pageToLoad,
  //       20
  //     );
  //
  //     const mapped = data?.map((item) =>
  //       lang === 'eng'
  //         ? {value: item?.id, label: item?.nameEn}
  //         : {value: item?.id, label: item?.name}
  //     );
  //
  //     setSubCategories(prev =>
  //       replace ? mapped : [...prev, ...mapped]
  //     );
  //
  //     setSubCategoryPage(pageToLoad);
  //     setHasMoreSubCategories(data.length === 20);
  //   } catch (e) {
  //   }finally {
  //     setLoadingSubCategories(false);
  //   }
  // };
  const fetchPotentionalRisks = async () => {
    try {
      const {data} = await getPotentionalRisks();
      return data;
    } catch (e) {}
  };

  useEffect(() => {
    fetchPotentionalRisks().then((r) => {
      let options = [];
      r.forEach((item) => {
        options.push({
          value: item.id,
          label: item.title,
        });
      });
      setPotentionalRisks(options);
    });

    if (
      props?.location?.state !== null &&
      props?.location?.state !== undefined
    ) {
      const potentialId = props?.location?.state.potentialId;
      const potentialTitle = props?.location?.state.potentialTitlе;
      setValue(
        'riskType',
        {value: potentialId, label: potentialTitle},
        {
          shouldValidate: false,
          shouldDirty: false,
        }
      );
    }
  }, []);
  useEffect(() => {
    if (watchRiskType?.value) {
      setDisabled(false);
      const fetchRiskData = async () => {
        try {
          const {data} = await GetPotentionalRisk(watchRiskType?.value);
          setRiskEstimation(data[0].riskEstimationId);
          setValue('description', data[0].description, {
            shouldValidate: true,
            shouldDirty: false,
          });
          if (data[0].estimatedGrossLost !== null) {
            setValue('estimatedGrossLost', data[0].estimatedGrossLost, {
              shouldValidate: true,
              shouldDirty: false,
            });
          }

          if (data[0].typeGainLossId !== null) {
            setValue(
              'typeGainLossId',
              {
                value: data[0].typeGainLossId,
                label:
                  lang === 'mne'
                    ? data[0].typeGainLossName
                    : data[0].typeGainLossNameEn,
              },
              {
                shouldValidate: true,
                shouldDirty: false,
              }
            );
          }
          setValue(
            'riskCategoryId',
            {
              value: data[0].riskCategoryId,
              label:
                lang === 'mne'
                  ? data[0].riskCategoryName
                  : data[0].riskCategoryNameEn,
            },
            {
              shouldValidate: true,
              shouldDirty: false,
            }
          );
          if (data[0].subcategoryId !== null) {
            setValue(
              'riskSubCategory',
              {
                value: data[0].subcategoryId,
                label:
                  lang === 'mne'
                    ? data[0].subcategoryName
                    : data[0].subcategoryNameEn,
              },
              {
                shouldValidate: true,
                shouldDirty: false,
              }
            );
          }
          // setValue(
          //   'methodologyId',
          //   {
          //     value: data[0].methodologyId,
          //     label:
          //       lang === 'mne'
          //         ? data[0].methodologyName
          //         : data[0].methodologyNameEn,
          //   },
          //   {
          //     shouldValidate: true,
          //     shouldDirty: false,
          //   }
          // );
          setValue(
            'departmentStakeholderId',
            {
              value: data[0].departmentStakeholderId,
              label:
                lang === 'mne'
                  ? data[0].departmentStakeholderName
                  : data[0].departmentStakeholderNameEn,
            },
            {
              shouldValidate: true,
              shouldDirty: false,
            }
          );
         
          if (data[0].businessLineId !== null) {
            setValue(
              'businessLineId',
              {
                value: data[0].businessLineId,
                label:
                  lang === 'mne'
                    ? data[0].businessLineName
                    : data[0].businessLineNameEn,
              },
              {
                shouldValidate: true,
                shouldDirty: false,
              }
            );
          }
          setValue(
            'subprocessId',
            {
              value: data[0].subprocessId,
              label:
                lang === 'mne'
                  ? data[0].subprocessName
                  : data[0].subprocessNameEn,
            },
            {
              shouldValidate: true,
              shouldDirty: false,
            }
          );
          setValue(
            'riskCauseId',
            {
              value: data[0].riskCauseId,
              label:
                lang === 'mne'
                  ? data[0].riskCauseName
                  : data[0].riskCauseNameEn,
            },
            {
              shouldValidate: true,
              shouldDirty: false,
            }
          );
          setValue(
            'riskSubCauseId',
            {
              value: data[0].riskSubCauseId,
              label:
                lang === 'mne'
                  ? data[0].riskSubCauseName
                  : data[0].riskSubCauseNameEn,
            },
            {
              shouldValidate: true,
              shouldDirty: false,
            }
          );
          setValue(
            'process',
            {
              value: data[0].processId,
              label:
                lang === 'mne' ? data[0].processName : data[0].processNameEn,
            },
            {
              shouldValidate: true,
              shouldDirty: false,
            }
          );
        } catch (err) {
          // console.log(err, 'error');
        }
      };

      fetchRiskData();
    }
  }, [watchRiskType]);

  const handleCancel = (e) => {
    e.preventDefault();
    window.location = '/dashboard';
  };
  const submitForm = async (data) => {
    const files = document.getElementById('upload').files;
    const date = format(new Date(data.eventOccurrence), "yyyy-MM-dd'T'HH:mm:ss")
    const formatDateOfEventDiscovered = format(new Date(data.riskOccurrenceDiscoveredAt), "yyyy-MM-dd'T'HH:mm:ss")
    const riskTypes = await getAllRiskTypes();
    // 2 because riskTypeId is 2 in payload
    const isDelayedVerification = riskTypes?.data.find((riskType) => riskType.id === 2).delayedVerification;

    const payload = {
      riskTypeId: 2,
      potentialRiskId: data?.riskType.value,
      title: data?.title,
      description: data?.description,
      harmfulEventDescription: data?.harmfulEventDescription,
      typeGainLossId: data?.typeGainLossId.value,
      // methodologyId: data?.methodologyId.value,
      riskCauseId: data?.riskCauseId.value,
      riskSubCauseId: data?.riskSubCauseId.value,
      departmentStakeholderId: data?.departmentStakeholderId.value,
      riskCategoryId: data?.riskCategoryId.value,
      subcategoryId: data?.riskSubCategory?.value,
      userResponsibleId: data?.userResponsible.value,
      userResponsibleLogin: userResponsibleLogin,
      subprocessId: data?.subprocessId.value,
      estimatedGrossLost: parseFormattedNumber(data?.estimatedGrossLost),
      comment: data?.comment,
      riskMitigationModeId: data?.riskMitigationModeName?.value,
      riskMitigationModeName: data?.riskMitigationModeName?.label,
      creditRiskRelated: data?.creditRiskRelated.value,
      businessLineId: data?.businessLineId.value,
      userCreatedId: user.id,
      riskEstimationId: riskEstimation,
      departmentSourceId: data?.departmentSourceId.value,
      harmfulOperationalRiskOccurrenceDate: date,
      riskOccurrenceDiscoveredAt: formatDateOfEventDiscovered,
      delayedVerification: isDelayedVerification,
      riskExpenseDTO: lossData.length > 0 ? lossData.map((item) => (
          {
            lossReason: {
              id:item?.lossReason.value,
              name: item?.lossReason.label
            },
            netLoss: parseFormattedNumber(item?.netLoss),
            lossDate: item?.lossDate
          }
      )) : [],
      keyIndicatorId: data?.keyIndicatorId?.value,
      keyIndicatorValue: data?.keyIndicatorValue,
      netLoss: parseFormattedNumber(data?.netLossNumber),
      grossLoss: parseFormattedNumber(data?.grossLoss),
      lossChargedInsurance: parseFormattedNumber(data?.lossChargedInsurance),
      lossChargedOther: parseFormattedNumber(data?.lossChargedOther),
    };
    try {
      const response = await addIncurredRisk(payload, files);
      if (response.status === 201) {
        await Toast.fire({
          title: t('message.addSuccess2', {entity: t('common.incurred-risk')}),
          icon: 'success',
        });
        setIsAdding(false);
      }
      await history.push(`/incurred-risk/${response.data?.id}`);
    } catch (err) {
      if (err.response.data.code === 'risk-exists') {
        Swal.fire({
          text:
            lang === 'eng'
              ? err.response.data.description
              : t('message.addRiskErrorExists'),
          icon: 'error',
        });
        document.getElementById('title').focus();
        document.getElementById('title').select();
      } else {
        Toast.fire({
          title: t('message.errorApi'),
          icon: 'error',
        });
        setIsAdding(false);
      }
    }
  };
  // useEffect(() => {
  //   if (watchRiskCause?.value) {
  //     setDisableSubCauses(false);
  //
  //     const causeChanged =
  //       prevRiskCause.current !== undefined &&
  //       prevRiskCause.current !== watchRiskCause.value;
  //
  //     if (causeChanged) {
  //       setValue('riskSubCauseId', null, {
  //         shouldValidate: false,
  //         shouldDirty: false,
  //       });
  //
  //       setSubCauses([]);
  //       setSubCausePage(0);
  //       setHasMoreSubCauses(true);
  //     }
  //
  //     prevRiskCause.current = watchRiskCause.value;
  //     fetchSubcauses(0, true);
  //   } else {
  //     setDisableSubCauses(true);
  //     setSubCauses([]);
  //     setSubCausePage(0);
  //     setHasMoreSubCauses(true);
  //     prevRiskCause.current = undefined;
  //
  //     setValue('riskSubCauseId', null, {
  //       shouldValidate: false,
  //       shouldDirty: false,
  //     });
  //   }
  // }, [watchRiskCause]);
  //
  // useEffect(() => {
  //   if (watchProcess?.value) {
  //     setDisableSubPorcess(false);
  //
  //     const processChanged =
  //       prevProcessRef.current !== undefined &&
  //       prevProcessRef.current !== watchProcess.value;
  //
  //     if (processChanged) {
  //       setValue('subprocessId', '', {
  //         shouldValidate: false,
  //         shouldDirty: false,
  //       });
  //       setSubProcesses([]);
  //       setSubprocessPage(0);
  //       setHasMoreSubprocesses(true);
  //     }
  //     prevProcessRef.current = watchProcess.value;
  //     fetchSubprocesses(0, true);
  //   } else {
  //     setDisableSubPorcess(true);
  //     setSubProcesses([]);
  //     setSubprocessPage(0);
  //     setHasMoreSubprocesses(true);
  //     prevProcessRef.current = undefined;
  //
  //     setValue('subprocessId', '', {
  //       shouldValidate: false,
  //       shouldDirty: false,
  //     });
  //   }
  // }, [watchProcess]);
  // useEffect(() => {
  //   if (watchRiskCategory?.value) {
  //     setDisableSubCategories(false);
  //
  //     const categoryChanged =
  //       prevRiskCategory.current !== undefined &&
  //       prevRiskCategory.current !== watchRiskCategory?.value;
  //
  //     if (categoryChanged) {
  //       setValue('riskSubCategory', null, {
  //         shouldValidate: false,
  //         shouldDirty: false,
  //       });
  //
  //       setValue('riskCauseId', null, {
  //         shouldValidate: false,
  //         shouldDirty: false,
  //       });
  //
  //       setValue('riskSubCauseId', null, {
  //         shouldValidate: false,
  //         shouldDirty: false,
  //       });
  //
  //       setDisableRiskCauses(true);
  //       setDisableSubCauses(true);
  //
  //       setSubCategories([]);
  //       setSubCategoryPage(0);
  //       setHasMoreSubCategories(true);
  //
  //       setSubCauses([]);
  //       setSubCausePage(0);
  //       setHasMoreSubCauses(true);
  //     }
  //
  //     prevRiskCategory.current = watchRiskCategory?.value;
  //     fetchSubCategories(0, true);
  //   } else {
  //     setDisableSubCategories(true);
  //     setDisableRiskCauses(true);
  //     setDisableSubCauses(true);
  //
  //     setSubCategories([]);
  //     setSubCategoryPage(0);
  //     setHasMoreSubCategories(true);
  //
  //     setSubCauses([]);
  //     setSubCausePage(0);
  //     setHasMoreSubCauses(true);
  //
  //     prevRiskCategory.current = undefined;
  //
  //     setValue('riskSubCategory', null, {
  //       shouldValidate: false,
  //       shouldDirty: false,
  //     });
  //
  //     setValue('riskCauseId', null, {
  //       shouldValidate: false,
  //       shouldDirty: false,
  //     });
  //
  //     setValue('riskSubCauseId', null, {
  //       shouldValidate: false,
  //       shouldDirty: false,
  //     });
  //   }
  // }, [watchRiskCategory]);
  // useEffect(() => {
  //   if (watchRiskCategory?.value && watchRiskSubCategory?.value) {
  //     setDisableRiskCauses(false);
  //   } else {
  //     setDisableRiskCauses(true);
  //     setDisableSubCauses(true);
  //
  //     setValue('riskCauseId', null, {
  //       shouldValidate: false,
  //       shouldDirty: false,
  //     });
  //
  //     setValue('riskSubCauseId', null, {
  //       shouldValidate: false,
  //       shouldDirty: false,
  //     });
  //
  //     setSubCauses([]);
  //     setSubCausePage(0);
  //     setHasMoreSubCauses(true);
  //   }
  // }, [watchRiskCategory, watchRiskSubCategory]);

  useEffect(() => {
    if (watchDepartmentSourceId) {
      const depratmentObject = async () => {
        try {
          const {data} = await getDepartment(watchDepartmentSourceId.value);
          setUserResponsibleLogin(data[0]?.userResponsibleLogin)
          setValue('userResponsible', {
            value: data[0].userResponsibleId,
            label:
              data[0].userResponsibleFirstName +
              ' ' +
              data[0].userResponsibleLastName,
          });
        } catch {}
      };
      depratmentObject();
    }
  }, [watchDepartmentSourceId]);

    const deleteConto = (id) => {
      setLossModalOpen(false);

      const itemToDelete = lossData.find(
        (item) => item.id === id || item.tempId === id
      );

      if (itemToDelete && typeof itemToDelete?.id === 'number') {
        setDeletedLossIds((prev) => [...prev, itemToDelete.id]);
      }

      setLossData((prevLossData) =>
        prevLossData.filter(
          (item) => item.id !== id && item.tempId !== id
        )
      );
    };

  useEffect(() => {
    const index = lossData.findIndex((loss) => loss.id === currentID);
    if (index !== -1) {
      const selectedLoss = lossData[index];
      setValue(`lossData.${index}.account`, selectedLoss?.lossReason);
    }
  },[lossData]);

  const handleSubprocessLoadMore = () => {
    if (hasMoreSubprocesses && !loadingSubprocesses) {
      // fetchSubprocesses(subprocessPage + 1, false);
    }
  };

  const handleRiskSubCauseLoadMore = () => {
    if (hasMoreSubCauses && !loadingSubCauses) {
      // fetchSubcauses(subCausePage + 1, false);
    }
  };
  const handleRiskSubCategoryLoadMore = () => {
    if (hasMoreSubCategories && !loadingSubCategories) {
      // fetchSubCategories(subCategoryPage + 1, false);
    }
  };
  const sum = lossData.reduce((acc, item) => {
    const value = parseFormattedNumber(item?.netLoss) || 0;
    return acc + value;
  }, 0);
  const netLossNumberValue = sum -
    parseFormattedNumber(watch('lossChargedInsurance')) -
    parseFormattedNumber(watch('lossChargedOther'))

  const handleChange = (event) => {
    event.target.value = formatNumberInput(event.target.value);
  };
  return (
    <>
      <PreventTransitionPrompt when={isAdding} />
      <PageHeader />
      <div className="main-form mt-4">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(submitForm)}>
            <Row className="field-group-title">
              <Col className="col-4 col-xl-2">
                {t('incurred-risk.mainData')}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col className="col-6 col-xl-3">
                <label className="label-incurred">
                  {t('incurred-risk.potentionalRisk')}
                </label>
                <SelectInfinite
                  api="/risks?riskTypeId.equals=1&riskStatusId.in=1,2,3"
                  name="riskType"
                  placeholder={t('incurred-risk.placeholder.potentionalRisk')}
                  labelKey={'title'}
                  className="select"
                  isClearable
                  queryKeys={'title.contains'}
                  isSelectWithId={true}
                />
                <label className="label-incurred">
                  {t('incurred-risk.title')}
                </label>
                <InputText
                  type="text"
                  name="title"
                  className="form-control input-field"
                  placeholder={t('incurred-risk.placeholder.title')}
                  disabled={disabled}
                  id="title"
                />
                <label className="label-incurred">
                  {t('incurred-risk.keyIndicatorId')}
                </label>
                <span className="optional register">
                  {t('common.optional')}
                </span>
                <SelectInfinite
                  api="/key-indicators?activate.equals=true"
                  isKeyIndicator={true}
                  name="keyIndicatorId"
                  placeholder={t('incurred-risk.placeholder.keyIndicatorId')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                  isClearable
                  queryKeys={lang === 'mne' ? 'indicatorName.contains' : 'indicatorNameEn.contains'}
                />
              </Col>
              <Col className="col-6 col-xl-3 ">
                <label className="label-incurred">
                  {t('incurred-risk.descriptionRisk')}
                </label>
                <TextArea
                  name="description"
                  className="form-control text-area"
                  placeholder={t('incurred-risk.placeholder.descriptionRisk')}
                  disabled={true}
                />
                {(watchKeyRiskIndicator?.escalationCalculationType !== 'COUNTER' && watchKeyRiskIndicator !== null) && <>
                    <label className="label pt-2" htmlFor="value">
                      {t('Pages.ViewKeyRiskIndicator.value')}
                    </label>
                    <InputText
                      name="keyIndicatorValue"
                      type="number"
                      className="form-control"
                      placeholder={t("Pages.ViewKeyRiskIndicator.placeholderValue")}
                    />
                  </>}
              </Col>
              <Col className="col-6 col-xl-3 ">
                <label className="label-incurred">
                  {t('incurred-risk.description')}
                </label>
                <TextArea
                  name="harmfulEventDescription"
                  className="form-control text-area"
                  placeholder={t('incurred-risk.placeholder.description')}
                  disabled={disabled}
                />
              </Col>
            </Row>
            <Row className="mt-5 field-group-title">
              <Col className="col-4 col-xl-2">
                {t('incurred-risk.additionalInformation')}
              </Col>
            </Row>
            <Row className="mt-2">
              <Col className="col-3 col-xl-3">
                <label className="label-incurred">
                  {t('incurred-risk.category')}
                </label>
                <SelectInfinite
                  api="risk-categories?active.equals=true"
                  name="riskCategoryId"
                  placeholder={t('incurred-risk.placeholder.category')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                  isDisabled={true}
                />
                <label className="label-incurred">
                  {t('incurred-risk.riskSubCategory')}
                </label>
                <SelectList
                  name="riskSubCategory"
                  isDisabled={true}
                  className="select"
                  placeholder={t('incurred-risk.placeholder.riskSubCategory')}
                  options={subCategories}
                  isClearable
                  onLoadMore={handleRiskSubCategoryLoadMore}
                  hasMore={hasMoreSubCategories}
                  isLoading={loadingSubCategories}
                />
                <label className="label-incurred">
                  {t('incurred-risk.riskCauses')}
                </label>
                <SelectInfinite
                  // key={`riskCause-${watchRiskSubCategory?.value || 'empty'}`}
                  api={
                    watchRiskSubCategory?.value
                      ? `risk-causes?riskSubCategoryId.equals=${watchRiskSubCategory.value}`
                      : 'risk-causes'
                  }
                  name="riskCauseId"
                  placeholder={t('incurred-risk.placeholder.riskCauses')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                  ref={prevRiskCause}
                  isDisabled={true}
                />
                <label className="label-incurred">
                  {t('incurred-risk.subCauses')}
                </label>
                <SelectList
                  name="riskSubCauseId"
                  isDisabled={true}
                  className="select"
                  placeholder={t('incurred-risk.placeholder.subCauses')}
                  options={subCauses}
                  isClearable
                  onLoadMore={handleRiskSubCauseLoadMore}
                  hasMore={hasMoreSubCauses}
                  isLoading={loadingSubCauses}
                />
                <label className="label-litigation">
                  {t('potentialRisk.dateOfEventOccurrence')}
                </label>
                <InputDate
                    name="eventOccurrence"
                    placeholder={t('potentialRisk.placeholder.selectDate')}
                    style={{height: '45px!important', width: '100%'}}
                    isClearable={true}
                    disabled={disabled}
                    // maxDate={new Date()}
                />
              </Col>
              <Col className="col-3 col-xl-3">
                <label className="label-incurred">
                  {t('incurred-risk.process')}
                </label>
                <SelectInfinite
                  api="processes?active.equals=true"
                  name="process"
                  placeholder={t('incurred-risk.placeholder.process')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                  ref={prevProcessRef}
                  isDisabled={true}
                />
                <label className="label-incurred">
                  {t('incurred-risk.subprocess')}
                </label>
                <SelectList
                  name="subprocessId"
                  isDisabled={true}
                  className="select"
                  placeholder={t('incurred-risk.placeholder.subprocess')}
                  options={subProcesses}
                  isClearable
                  onLoadMore={handleSubprocessLoadMore}
                  hasMore={hasMoreSubprocesses}
                  isLoading={loadingSubprocesses}
                />
                <label className="label-incurred">
                  {t('incurred-risk.businessLines')}
                </label>
                <SelectInfinite
                  api="business-lines"
                  name="businessLineId"
                  placeholder={t('incurred-risk.placeholder.businessLines')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                  isDisabled={true}
                />
                {/*<label className="label-incurred">*/}
                {/*  {t('incurred-risk.metodologies')}*/}
                {/*</label>*/}
                {/*<SelectInfinite*/}
                {/*  api="methodologies"*/}
                {/*  name="methodologyId"*/}
                {/*  placeholder={t('incurred-risk.placeholder.metodologies')}*/}
                {/*  labelKey={lang === 'mne' ? 'name' : 'nameEn'}*/}
                {/*  className="select"*/}
                {/*  isDisabled={disabled}*/}
                {/*/>*/}
                <label className="label-litigation">
                  {t('potentialRisk.riskOccurrenceDiscoveredAt')}
                </label>
                <InputDate
                  name="riskOccurrenceDiscoveredAt"
                  placeholder={t('potentialRisk.placeholder.selectDate')}
                  style={{height: '45px!important', width: '100%'}}
                  isClearable={true}
                  disabled={disabled}
                  minDate={watch('eventOccurrence')}
                />
                <label className="label-incurred">
                  {t('incurred-risk.attachFile')}
                </label>
                <FileUploadSection disabled={disabled}/>
              </Col>
              <Col className="col-3 col-xl-3">
                <label className="label-incurred">
                  {t('incurred-risk.typeGainLoss')}
                </label>
                <SelectInfinite
                    api="type-gain-losses"
                    name="typeGainLossId"
                    placeholder={t('incurred-risk.placeholder.typeGainLoss')}
                    labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                    className="select"
                    isDisabled={disabled}
                />
                <label className="label-incurred">
                  {t('incurred-risk.isEventConnected')}
                </label>
                <SelectList
                  name="creditRiskRelated"
                  className="select"
                  options={yesNoOptions}
                  placeholder={t('incurred-risk.isEventConnectedPlaceholder')}
                  isClearable={false}
                  errors={errors}
                  isDisabled={disabled}
                />
                <label className="label-incurred">
                  {t('incurred-risk.estimatedGrossLoss')}
                </label>
                <InputText
                  type="text"
                  name="estimatedGrossLost"
                  className="form-control input-field"
                  placeholder={t(
                    'incurred-risk.placeholder.estimatedGrossLoss'
                  )}
                  disabled={disabled}
                  onChange={(e) => onDecimalNumberInputChange(e,setValue,"estimatedGrossLost")}
                  onPaste={(e) => handlePasteAndValidate(e, setValue, trigger, 'estimatedGrossLost')}
                />
                <label className="label-incurred">
                  {t('mitigation-measures.method')}
                </label>
                <SelectInfinite
                  api="/risk-mitigation-modes"
                  name="riskMitigationModeName"
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                  placeholder={t('placeholder.riskMitigrationMethod')}
                  isDisabled={disabled}
                />
              </Col>
              <Col className="col-3 col-xl-3">
                <label className="label-potential-risk">
                  {t('potentialRisk.departmentRisk')}
                </label>
                {userDepartment?.length === 1 ? (
                  <SelectInfinite
                    api={`departments/departments-user-in-charge?appModuleId.equals=${appModules?.riskModule}&active.equals=true`}
                    name="departmentSourceId"
                    placeholder={t('potentialRisk.placeholder.departmentRisk')}
                    labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                    className="select"
                    defaultValue={{
                      value:
                        userDepartment[0]?.id !== undefined
                          ? userDepartment[0]?.id
                          : '',
                      label:
                        userDepartment[0]?.id !== undefined
                          ? lang === 'mne'
                            ? userDepartment[0]?.name
                            : userDepartment[0]?.nameEn
                          : '',
                    }}
                    isDisabled={true}
                  />
                ) : (
                  <SelectInfinite
                    api={`departments/departments-user-in-charge?appModuleId.equals=${appModules?.riskModule}&active.equals=true`}
                    name="departmentSourceId"
                    placeholder={t('potentialRisk.placeholder.departmentRisk')}
                    labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                    className="select"
                    isDisabled={disabled}

                  />
                )}
                <label className="label-incurred">
                  {t('incurred-risk.department')}
                </label>
                <SelectInfinite
                  api={`departments?appModuleId.equals=${appModules?.riskModule}&active.equals=true`}
                  name="departmentStakeholderId"
                  placeholder={t('incurred-risk.placeholder.department')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                  isDisabled={true}
                />
                {userDepartment?.length === 1 ? (
                  <>
                    <label className="label-potential-risk">
                      {t('incurred-risk.responsibleUser')}
                    </label>
                    <SelectInfinite
                      api="users"
                      name="userResponsible"
                      labelKey="firstName"
                      placeholder={t(
                        'incurred-risk.placeholder.responsibleUser'
                      )}
                      className="select"
                      isDisabled={true}
                      defaultValue={{
                        value:
                          userDepartment[0]?.id !== undefined
                            ? userDepartment[0]?.userResponsibleId
                            : '',
                        label:
                          userDepartment[0]?.id !== undefined
                            ? userDepartment[0]?.userResponsibleFirstName +
                            ' ' +
                            userDepartment[0]?.userResponsibleLastName
                            : '',
                      }}
                    />
                  </>
                ) : (
                  <>
                    <label className="label-potential-risk">
                      {t('incurred-risk.responsibleUser')}
                    </label>
                    <SelectInfinite
                      api="users"
                      name="userResponsible"
                      labelKey="firstName"
                      placeholder={t(
                        'incurred-risk.placeholder.responsibleUser'
                      )}
                      className="select"
                      isDisabled={true}
                    />
                  </>
                )}
                <label className="label-incurred">
                  {t('incurred-risk.additionalComment')}
                </label>
                <span className="optional register">
                  {t('common.optional')}
                </span>
                <TextArea
                    name="comment"
                    className="form-control text-area"
                    placeholder={t('incurred-risk.placeholder.additionalComment')}
                    disabled={disabled}
                />
              </Col>
            </Row>
            <Row className="mb-2 occured-loss-footer">
              <Col className="col-3 col-xl-3">
              <label className="label-incurred">
                {t('codebook.addIncurredLoss')}
              </label>
              <span className="optional register">
                  {t('common.optional')}
                </span>
              <p className={'file-input'} style={{marginBottom: '-8px'}} onClick={() => {
                setIsEdit(false)
                setLossModalOpen(true)
              }}></p>
              <LossModal
                  open={lossModalOpen}
                  setLossData={setLossData}
                  lossData={lossData}
                  id={currentID}
                  isEdit={isEdit}
                  isOpen={(e) => setLossModalOpen(e)}
              />
              </Col>
            </Row>
            <Row>
              {lossData.map((item,index) => (
                  <>
                    <Col className="col-3 col-xl-3">
                      <label className="label-incurred">
                        {t('codebook.codebook')}
                      </label>
                      <SelectInfinite
                          api="/loss-reasons"
                          name={`lossData.${index}.account`}
                          placeholder={t('incurred-risk.placeholder.category')}
                          labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                          className="select"
                          isDisabled={true}
                          defaultValue={item?.lossReason}
                      />
                    </Col>
                    <Col className="col-3 col-xl-3" style={{marginRight: '5px'}}>
                      <label className="label-incurred">
                        {t('codebook.lossDate')}
                      </label>
                      <InputDate
                          name="lossDate"
                          selected={new Date(item?.lossDate)}
                          placeholder={t('codebook.lossDatePlaceholder')}
                          style={{height: '65px!important'}}
                          forceSelected={true}
                          disabled={true}
                          isClearable={false}
                      />
                    </Col>
                    <Col className="col-3 col-xl-3" style={{marginRight: '5px'}}>
                      <label className="label-incurred">
                        {t('codebook.loss')}
                      </label>
                      <InputText
                          type="text"
                          name="netLoss"
                          className="form-control input-field"
                          placeholder={t('incurred-risk.placeholder.title')}
                          disabled={true}
                          value={item?.netLoss}
                      />
                    </Col>
                    <div style={{width: '10%',display:'flex',marginLeft: '20px',alignItems:'center'}}>
                      <img style={{marginTop: '30px',marginRight: '5px',cursor: 'pointer'}} onClick={() => {
                        setLossModalOpen(true)
                        setCurrentID(item.id ?? item.tempId);
                        setIsEdit(true);
                      }} src={editImage} alt={'edit'}/>
                      <img style={{marginTop: '30px',cursor: 'pointer'}} onClick={() => deleteConto(item?.id ?? item?.tempId)} src={deleteImage} alt={'delete'}/>
                    </div>
                  </>
              ))}
            </Row>
            <Row>
              {watchNetLoss &&
                <>
                  <Col className="col-3">
                    <label className="label-incurred">
                      {t('litigation.grossLoss')}
                    </label>
                    <InputText
                      type="text"
                      name="grossLoss"
                      className="form-control input-field"
                      placeholder={t('litigation.placeholder.placeholder.grossLoss')}
                      disabled={true}
                      value={formatNumber(sum)}
                    />
                  </Col>
                  <Col className="col-3">
                    <label className="label-incurred">
                      {t('litigation.lossChargedInsurance')}
                    </label>
                    <InputText
                      type="text"
                      name="lossChargedInsurance"
                      onChange={handleChange}
                      className="form-control input-field"
                      placeholder={t('litigation.placeholder.lossChargedInsurance')}
                    />
                  </Col>
                  <Col className="col-3">
                    <label className="label-incurred">
                      {t('litigation.lossChargedOther')}
                    </label>
                    <InputText
                      type="text"
                      name="lossChargedOther"
                      className="form-control input-field"
                      onChange={handleChange}
                      placeholder={t('litigation.placeholder.lossChargedOther')}
                    />
                  </Col>
                  <Col className="col-3">
                    <label className="label-incurred">
                      {t('litigation.netLossNumber')}
                    </label>
                    <InputText
                      type="text"
                      name="netLossNumber"
                      className="form-control input-field"
                      placeholder={t('litigation.placeholder.netLossNumber')}
                      disabled={true}
                      value={formatNumber(netLossNumberValue)}
                    />
                  </Col>
                </>}
            </Row>
            <Row className="mt-3 form-footer">
              <button
                className="secondary-btn"
                type="reset"
                onClick={handleCancel}
              >
                {t('buttons.cancel')}
              </button>
              <button className="primary-btn" type="submit">
                {t('buttons.save')}
              </button>
            </Row>
          </form>
        </FormProvider>
      </div>
    </>
  );
};

export default AddIncurredRisk;
